import { render, staticRenderFns } from "./MultipleSelectCustomerName.vue?vue&type=template&id=589d786b&scoped=true&"
import script from "./MultipleSelectCustomerName.vue?vue&type=script&lang=js&"
export * from "./MultipleSelectCustomerName.vue?vue&type=script&lang=js&"
import style0 from "./MultipleSelectCustomerName.vue?vue&type=style&index=0&id=589d786b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d786b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
